import React from "react";
import { Flame } from "lucide-react";
import { useBatch, pizzasLeft, stockText } from "@/context/BatchContext";

export default function BatchStockBadge({ testid = "batch-stock-badge", className = "" }) {
  const { batch, display } = useBatch();
  const left = pizzasLeft(batch);
  if (left === null) return null;
  const tone = left === 0 ? "bg-biga-ink text-biga-cream" : "bg-biga-green text-biga-cream";
  return (
    <span data-testid={testid} data-left={left} className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide px-3 py-1.5 rounded-full ${tone} ${className}`}>
      <Flame size={13} /> {stockText(left, display)}
    </span>
  );
}
